import { revokeAllSessions } from "@/lib/authBackend/revokeAllSessions";
import type { SignOutArgs } from "@/lib/authBackend/types";
import { tidClient } from "./client";

export async function signOut(args?: SignOutArgs): Promise<void> {
  if (args?.global) await revokeAllSessions();
  if (!tidClient) {
    if (args?.redirectTo) window.location.replace(args.redirectTo);
    return;
  }
  await tidClient.logout(args?.redirectTo ? { redirectTo: args.redirectTo } : undefined);
}
